import { api } from "./api";
import { getSessionId, getUtm, getLandingPath, isReturningVisitor, getCampaignSlug } from "./utm";

function detectDevice() {
  const ua = navigator.userAgent;
  if (/mobile|android|iphone|ipad/i.test(ua)) return "mobile";
  return "desktop";
}

function detectBrowser() {
  const ua = navigator.userAgent;
  if (/tiktok/i.test(ua)) return "tiktok";
  if (/instagram/i.test(ua)) return "instagram";
  if (/fban|fbav/i.test(ua)) return "facebook";
  if (/edg/i.test(ua)) return "edge";
  if (/chrome/i.test(ua)) return "chrome";
  if (/safari/i.test(ua)) return "safari";
  if (/firefox/i.test(ua)) return "firefox";
  return "other";
}

// Fire-and-forget analytics. Never throws — playback must keep working.
export function track(eventType, extra = {}) {
  const utm = getUtm();
  const payload = {
    eventType,
    sessionId: getSessionId(),
    utmSource: utm.utm_source || null,
    utmMedium: utm.utm_medium || null,
    utmCampaign: utm.utm_campaign || null,
    utmContent: utm.utm_content || null,
    utmTerm: utm.utm_term || null,
    referrer: document.referrer || null,
    device: detectDevice(),
    browser: detectBrowser(),
    path: window.location.pathname,
    landingPath: getLandingPath(),
    isReturning: isReturningVisitor(),
    campaignSlug: getCampaignSlug(),
    ...extra,
  };
  api.post("/analytics/event", payload).catch(() => {});
  if (typeof window.gtag === "function") {
    try {
      window.gtag("event", eventType, {
        release_id: payload.releaseId, campaign: payload.utmCampaign, source: payload.utmSource,
        campaign_slug: payload.campaignSlug, ...(extra.metadata || {}),
      });
    } catch {}
  }
}

// Outbound platform click → `<platform>_click` (spotify_click, apple_music_click, tiktok_click …)
export function trackOutbound(platform, extra = {}) {
  track(`${platform}_click`, extra);
}
